/**
 * Session persistence — localStorage-backed session token + player identity for
 * reconnect (REJOIN). Final exported signatures; Wave 1 A5 fills the bodies.
 */

export interface StoredSession {
  code: string;
  playerId: string;
  sessionToken: string;
}

const KEY_PREFIX = 'ringmaster:session:';

/** Persist a session for a room code. */
export function saveSession(session: StoredSession): void {
  // TODO(A5): write to localStorage keyed by code.
  try {
    localStorage.setItem(KEY_PREFIX + session.code, JSON.stringify(session));
  } catch {
    // ignore storage failures (private mode etc.)
  }
}

/** Load a stored session for a room code, or null. */
export function loadSession(code: string): StoredSession | null {
  // TODO(A5): read + validate from localStorage.
  try {
    const raw = localStorage.getItem(KEY_PREFIX + code.toUpperCase());
    return raw ? (JSON.parse(raw) as StoredSession) : null;
  } catch {
    return null;
  }
}

/** Clear a stored session (e.g. on leave / game end). */
export function clearSession(code: string): void {
  try {
    localStorage.removeItem(KEY_PREFIX + code.toUpperCase());
  } catch {
    // ignore
  }
}
